import { api } from "services"

export async function getPlanners() {
  const { data } = await api.get("/planners?asList=1")

  return data
}